import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBeTvF_eM9wwoIhoITjmNJruKD_kJXdo3U",
  authDomain: "healthrely-ba3bc.firebaseapp.com",
  projectId: "healthrely-ba3bc",
  storageBucket: "healthrely-ba3bc.firebasestorage.app",
  messagingSenderId: "53193042163",
  appId: "1:53193042163:web:f40231bf993ad18ed7ef86",
  measurementId: "G-18MHSZ4NJV",
};
const app = initializeApp(firebaseConfig);

let messagingInstance = null;

export const getMessagingInstance = async () => {
  if (typeof window === 'undefined') return null;
  if (!messagingInstance) {
    const { getMessaging } = await import("firebase/messaging");
    messagingInstance = getMessaging(app);
  }
  return messagingInstance;
};
